import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import toUTCtime from '../../../../helper/UTCtime';
/*import PropTypes from 'prop-types'*/
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
// Request Prop
import {ExtendProps} from '../../request.props.js';

// Presenter
import {PresenterExtendDueDate} from '../../../presenter.js'
import { toast } from 'react-toastify';

export default class ModalExtend extends React.Component {
  constructor(props) {
    super(props);

    let tmpDate = new Date(moment()._d)
    
    tmpDate.setHours(8);
    tmpDate.setMinutes(59);
    tmpDate.setSeconds(59);    

    this.state = {
      dueDate    : null,
      dueDate_UTC: toUTCtime(tmpDate),
      minDate    : moment(),
      maxDate    : null,
      assetAlias : undefined,
      disabled   : false,
      is_process : false,
    }
    
    this.onExtend = this.onExtend.bind(this)
    this.onExtendSuccess = this.onExtendSuccess.bind(this)
    this.onExtendFailed = this.onExtendFailed.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(date){
    let tmpDate = new Date(date._d)
    
    tmpDate.setHours(8);
    tmpDate.setMinutes(59);
    tmpDate.setSeconds(59);
    
    this.setState({
      dueDate     : date,
      dueDate_UTC : toUTCtime(tmpDate)
    })
  }

  onExtend(){
    PresenterExtendDueDate(
      ExtendProps(this, this.onExtendSuccess, this.onExtendFailed)
    )
    this.setState({is_process: true}) 
  }
  onExtendSuccess(params, response){
    this.setState({is_process: false})
    toast.success("Extend duedate success")
    this.props.onSuccess(response.data);
    this.props.close();
  }
  onExtendFailed(error){    
    this.setState({is_process: false})
    try {
      toast.error(error.response.data.detail)
    }
    catch(error) {
      console.error(error);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    var maxDate = null;
    let disabled = false;

    if(nextProps.data !== undefined && nextProps.data !== null) {
      const {MaxDay} = nextProps.data;

      if(!nextProps.data.NextReservation) {
        maxDate = moment().add(MaxDay, 'days');
        disabled = false;
      } else {

        if(moment() > moment(nextProps.data.NextReservation.StartDate).subtract(1, 'days')) {
          if(moment() > moment(nextProps.data.NextReservation.FinishDate)) {
            maxDate = moment(nextProps.data.NextReservation.FinishDate)
          } else {
            maxDate = moment()
          }
          disabled = true; 

        } else if(moment().add(MaxDay, 'days') < moment(nextProps.data.NextReservation.StartDate).subtract(1, 'days')) {
          maxDate = moment().add(MaxDay, 'days');
          disabled = false;
          
        } else {
          maxDate = moment(nextProps.data.NextReservation.StartDate).subtract(1, 'days');
          disabled = false;
        }
      }

      if(nextProps.data.Tracking) {
        if(!this.state.dueDate) {
          if(moment(nextProps.data.Tracking.DueDate) <= moment()) {
            nextState.dueDate = moment()
          } else {
            nextState.dueDate = moment(nextProps.data.Tracking.DueDate)
          }
        }
      }

      if(this.state.maxDate === null || this.state.maxDate !== null ) {
        nextState.maxDate    = maxDate;
        nextState.assetAlias = nextProps.data.Alias;
        nextState.disabled   = disabled;
      }
    } else {
      nextState.dueDate = null
    }
    return true;
  }

  renderRestriction() {
    const {data} = this.props
    if(typeof data === "undefined" || data === null || data === undefined) {
      return null
    }else {
      if(this.state.disabled) {
        return (<p className="apple-red">{data.NextReservation.User.FirstName +" "+ data.NextReservation.User.LastName + " book the tool on " + moment(data.NextReservation.StartDate).format('YYYY-MM-DD') + ", Sorry you are not allowed to extend"}</p>)
        
      }else if(data.NextReservation === null) {
        return (<p className="apple-red">{"Max days allowed to extend is "+ data.MaxDay +" days."}</p>)
        
      }else if (data.NextReservation !== null){
        return (<p className="apple-red">{data.NextReservation.User.FirstName +" "+ data.NextReservation.User.LastName + " book the tool on " + moment(data.NextReservation.StartDate).format('YYYY-MM-DD') + ", you can extend until " + moment(data.NextReservation.StartDate).subtract(1, 'days').format('YYYY-MM-DD') }</p>)
      }
    }
  }

  render() {

    const {isToggle, close} = this.props 
    const {is_process} = this.state 
  
    return (
      <Modal isOpen={isToggle} toggle={close}>
        <ModalHeader toggle={close}>
          <span>Extend date</span>
        </ModalHeader>
        <ModalBody>
          <DatePicker
            className  ="form-control"
            selected   ={this.state.dueDate}
            dateFormat ="YYYY-MM-DD"
            minDate    ={this.state.minDate}
            maxDate    ={this.state.maxDate}
            readOnly   ={true}
            onChange   ={this.handleChange}
          />
          {this.renderRestriction()}
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={close}>Cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.onExtend()} disabled={this.state.disabled}>Extend</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}






// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalExtend.js